import { useGlobalState } from '@pepper/ui'

import s from './HomPageSkeletons.module.css'

export const CreateSingleVerticalProjectSkeleton = (): JSX.Element => {
  return (
    <div className={s.thumbnailWrapper}>
      {Array.from({ length: 5 }, (_, index) => (
        <div key={index} className={s.thumbnailBody} />
      ))}
    </div>
  )
}

export const RecentProjectsSkeleton = (): JSX.Element => {
  const { viewport } = useGlobalState()
  const isMobileView = viewport !== 'lg'

  return (
    <div className={s.projectsWrapper}>
      {Array.from({ length: isMobileView ? 3 : 6 }, (_, index) => (
        <div key={index} className={s.projectBody} />
      ))}
    </div>
  )
}
